import { ArrowDownIcon, ArrowUpIcon } from "@heroicons/react/24/outline";

import { DropdownMenuItem } from "@fronterahealth/frontera-ui-components/ui/dropdown-menu";

import {
  ReportSectionFieldsType,
  ReportSectionsType,
  useMoveReportSectionFieldUpAndDownMutation,
} from "@api/graphql/types-and-hooks";
import { notifyError } from "@components/notifications/notifications";
import { useReport } from "@providers/ReportProvider";

interface Props {
  section: ReportSectionsType;
  field: ReportSectionFieldsType;
}

export const ReportFieldDropdownMenuReorder: React.FC<Props> = ({ section, field }) => {
  const { reportQuery } = useReport();
  const { mutate: moveUpAndDownMutate } = useMoveReportSectionFieldUpAndDownMutation({
    onSuccess: async (data) => {
      if (data.moveReportSectionFieldUpAndDown?.status) {
        await reportQuery.refetch();
      } else if (data.moveReportSectionFieldUpAndDown?.status === false) {
        notifyError(data.moveReportSectionFieldUpAndDown?.message ?? "Error moving field");
      }
    },
    onError: (error) => {
      console.error("Error while moving field:", error);
      notifyError("Error Moving Field");
    },
  });

  const maxRankOnSection = section.sectionField.edges.reduce(
    (acc, item) => Math.max(acc, item?.node?.rankOrder ?? 0),
    0,
  );

  return (
    <>
      <DropdownMenuItem
        onClick={() => moveUpAndDownMutate({ reportSectionId: section.id, fieldId: field.id, moveUp: true })}
        disabled={field.rankOrder <= 1}
      >
        <ArrowUpIcon />
        Move Up
      </DropdownMenuItem>
      <DropdownMenuItem
        onClick={() => moveUpAndDownMutate({ reportSectionId: section.id, fieldId: field.id, moveUp: false })}
        disabled={field.rankOrder >= maxRankOnSection}
      >
        <ArrowDownIcon />
        Move Down
      </DropdownMenuItem>
    </>
  );
};
